import Helper from './Helper';

class Video {
  constructor() {
    const thumbnail = Array.prototype.slice.call(document.querySelectorAll(':not(.ns-youtubevideo) > .ns-video__inner > .ns-video__thumbnail'));
    thumbnail.forEach(image => {
      image.addEventListener('click', () => {
        const video = image.parentElement;
        // const button = video.querySelector('button');
        const iframe = video.querySelector('iframe');
        if (typeof iframe !== undefined && iframe !== null) {
          iframe.src = iframe.src + '?autoplay=1';
        } else {
          const localVideo = video.querySelector('video');
          // localVideo.autoplay = true;
          localVideo.play();
          localVideo.addEventListener('canplaythrough', () => {
            localVideo.play();
          });
        }

        // button.classList.add('fade-out');
        image.classList.add('fade-out');
        // button.style.display = 'none';
        image.style.display = 'none';
      });
    });
    const playbutton = Array.prototype.slice.call(document.querySelectorAll('.ns-youtubevideo .ns-video__playbutton'));
    playbutton.forEach(button => {

      button.addEventListener('click', () => {
        const youtubeVideo = button.parentElement.parentElement;

        youtubeVideo.parentElement.parentElement.parentElement.parentElement.classList.add('no-hover'); //add class so hover doesn't work anymore
        const thumbnail = button.parentElement;
        const iframe = youtubeVideo.querySelector('iframe');

        if(iframe.src.includes("?")){



          iframe.src = iframe.src + '&autoplay=1';
        } else {
          iframe.src = iframe.src + '?autoplay=1';

        }
        thumbnail.classList.add('fade-out');
        setTimeout(() => {
          thumbnail.style.display = 'none';
        }, 400);
      });
    });
  }


}

export default Video;

